/***************Enum Constants***************/

export enum AppEnv {
  Local = 'local',
  Dev = 'development',
  Stage = 'stage',
  QA = 'qa',
  Production = 'production'
}

export enum HttpHeader {
  ContentType = 'Content-Type',
  ApiKey = 'x-api-key',
  Token = 'access-token',
  Authorization = 'Authorization',
  CustomerShipTo = 'CustomerShipTo',
  loginShipToNumber = 'loginShipToNumber'

}

export enum HttpStatusCode {
  Timeout = 0,
  UnAuthorized = 401,
  BadRequest = 400,
  NotFound = 404,
  PreconditionRequired = 412,
  NoContent = 204
}

export enum ErrorNotificationType {
  Toast = 'TOASTER',
  Page = 'PAGE',
  Modal = 'MODAL',
}

export enum ErrorConfig {
  SysErrId = 'SYS100',
  BadRequestId = 'SYS400',
  NotFoundId = 'SYS404',
  PreconditionRequiredId = 'SYS412',
  TimeoutId = 'UI408',
}

export enum CacheDuration {
  Default = 24 * 60 * 60 * 1,
  OneMinute = 60 * 1,
  OneHour = 60 * 60 * 1,
  TwoHour = 60 * 60 * 2,
  OneDay = 24 * 60 * 60 * 1,
}

export enum Configuration {
  API_KEY = 'apiKey',
  UNDER_MAITENANCE = 'appDown',
  INTERNAL_URL = 'userInternalUrl',
  APP_TIMEOUT = 'appIdleTimeout',
  API_TIMEOUT = 'apiTimeout',
  OKTA_ISSUER = 'oktaIssuer',
  OKTA_CLIENT_ID = 'oktaClient',
  OKTA_REDIRECT_URL = 'oktaRedirect',
  OKTA_LOGOUT_URL = 'oktaLogout',
  PRODUCTION_FLAG = 'production',
  APIGEE_ENDPOINT = 'apigeeTokenEndpoint',
  CONFIG_API_ENDPOINT = 'configUrl',
  CONTENT_API_ENDPOINT = 'contentUrl',
  CONTRACT_API_ENDPOINT = 'accountContractUrl',
  PRODUCT_API_ENDPOINT = 'productUrl',
  ACCOUNT_MGMT_API_ENDPOINT = 'accountMgmtUrl',
  USER_API_ENDPOINT = 'userUrl',
  VENDOR_CONTRACT_API_ENDPOINT = 'vendorContractUrl',
  ACCOUNT_PAYABLE_API_ENDPOINT = 'accountPayableUrl',
  ACCOUNT_RCV_API_ENDPOINT = 'accountRcvUrl',
  FUSION_API_ENDPOINT = 'fusionUrl',
  APIGEE_TOKEN_ENDPOINT = 'apigeeTokenEndpoint',
  FEE_INDEXING_JOB_API_ENDPOINT = 'userFeeIndexJobUrl',
  REPORT_API_ENDPOINT = 'reportUrl',
  AUTO_CONVERSION_API_ENDPOINT = 'autoConversionJobUrl',
}

export enum Module {

}

export enum LogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  LOG = 'log',
  WARN = 'warn',
  ERROR = 'error',
}

export enum EncDecAlgo {
  AES = 'AES',
  DES = 'DES',
  TripleDES = 'TripleDES',
  RC4 = 'RC4',
  RC4Drop = 'RC4Drop',
  Rabbit = 'Rabbit',
  RabbitLegacy = 'RabbitLegacy',
  EvpKDF = 'EvpKDF',
}

export enum SignOutReason {
  Default = 1,
  Timeout = 2,
  SessionExpired = 3,
}

export enum SortDirections {
  Ascending = 'asc',
  Descending = 'desc',
}

export enum Pagination {
  DefaultPageNo = 1,
  DefaultPageSize = 10,
}

/***************Enum Constants***************/

export class AppConstant {
  static readonly Messages = {

    Schedule:{
      WOAlertHeader:"Look's like we are having some server issues",
WOAlertMessage:"Unfortunately our Web Ordering service is unable to complete this action. We are looking into the issue. Please try again by refreshing your page after a couple of minutes",
NoOrderingPhysician : "The ordering physician is missing. Please go to the Manage Procedure screen and select the ordering physician.",
MultipleComponents : "The selected procedure contains more than one component which cannot be ordered together. Please go to settings and split the procedure.",
TheranosticsProcedure : "Batch Scheduling is not available for this procedure, please use Schedule Procedure to complete process.",
AlternateProcedure : "The selected procedure cannot be scheduled for more than one patient at a time.",
TimeSlotExpired : "The below time-slot has been expired. Please select a new slot.",
BatchTitle : "Batch Schedule",
ScheduleTitle : "Schedule Procedure",
AddOrderTitle:'Add Order',
ReleaseSlot : "There is a hold on this time-slot.  Do you want to release it?",
VerifySentOrdersFailed : "We couldn’t send the below order automatically. Please contact the pharmacy.",
IsPastSpecialProductOrder : "The cutoff time for cancelation has been exceeded, the order cannot be canceled, would you like to still cancel the procedure?",
IsPastSpecialProductOrderDelete: "The cutoff time for cancelation has been exceeded, the order cannot be canceled, would you still like to delete the procedure",
onGaCallFailMessage: "Unfortunately our Web Ordering service is unable to complete this action.  Please try again by refreshing your page in a few minutes.  If you need immediate assistance, please call your pharmacy to place your order.",
CancelProcedureMessage:"Procedure cannot be cancelled for another truck, need to contact pharmacy.",
CancelComponentMessage:"<b>Component</b> cannot be cancelled for another truck, need to contact pharmacy.",
DeleteProcedureMessage:"Procedure cannot be deleted for another truck, need to contact pharmacy.",


    },
    Login: {
      Success: 'User has authenticated successfully.',
      Failed: 'User authentication was failed. Username: {username}, Error: {0}',
      UnAuthorized: 'User was authenticated successfully but unauthorized to access the application.',
      NotAllowedOnProd: 'Please use NPS User Management application for login.',
    },
    Logout: {
      Success: 'User \'\{0}\'\ has logged off successfully.',
      Timeout: 'User \'\{0}\'\ has logged off due to timeout activity.',
      SessionExpired: 'User \'\{0}\'\ has logged off due to session expired.'
    },
    SessionExpired: {
      Title: 'Session Expired',
      Message: 'Your session has expired. Please relogin.'
    },
    Offline: {
      Message: 'You are not connected to internet.'
    },
    User: {
      AssignRoleSuccess: 'Role has been assigned sucessfully',
      RemoveRoleSuccess: 'Role has been removed sucessfully',
      ResetPassword: 'Reset password link has been sent successfully',
      ResendActivation: 'Activation link has been sent successfully',
      SaveGroup: 'Group has been assigned successfully',
      RemoveGroup: 'Group has been removed successfully',
      PharmacyLocationSavedSuccesfully: "Pharmacy Preference Locations has been updated succesfully"
    },

    Aaa: {
      AaaConfigureSuccess: 'Accounts have been assigned successfully to AAA users',
      RemovedSuccessfully: 'Accounts have been removed successfully for AAA users',
      NoChangesToSave: 'There is no change to save',
      NoSearchResult: 'No account found with entered search criteria',
      ConfirmAccountRemovalTitle: 'Confirm Delete Accounts',
      ConfirmAccountRemoval: 'Are you sure you want to remove the accounts assigned to the AAA users?',
    },



    Digirad: {
      DigiradConfigureSuccess: 'Application Digirad Configured successfully!',
      MobileFacilityUpdateSuccess: 'Facility Updated successfully!',
      NoSearchResult: 'No account found with entered search criteria'
    },
    shipto: {
      ShipToRemovedSuccessfully: "Account has been removed successfully",
      XofigoAccountMappingSuccessfully: "Xofigo account has been mapped successfully",
      XofigoAccountMappingDeletedSuccessfully: "Xofigo account has been un-mapped successfully",
      AccountsSavedSuccessfully: 'Accounts have been saved successfully',
      RemoveShipToAccountTitle: "Confirm Delete Account",
      RemoveShipToAccountMessage: "Are you sure you want to remove nuctrac account?",
      FeaturesSavedSuccessfully: "Nuctrac features have been saved successfully.",
      StandingOrderSavedSuccessfully: "Monthly billing has been saved successfully",
      TrainingOrderPlacedSuccessfully: "Training order has been placed successfully",
      HardwareOrderPlacedSuccessfully: "Hardware order has been placed successfully",
      JobExecutedSuccessfully: "Monthly job has been executed successfully",
      OrderPlacementConfirmTitle: "Confirm Order Placement",
      OrderPlacedConfirmationMessage: "Are you sure you want to place this order?",
      IsLicenseAvailableTitle: "Error",
      IsLicenseAvailableMessage: "OTC01",
      SSOFlagEnabledSuccessFully: "Customer SSO preference has been changed successfully.",
      RETURNINVENTORYFlagEnabledSuccessFully: "Customer Return Inventory preference has been changed successfully.",
      SettingsFlag: "Customer SSO and Return Inventory preference has been changed successfully.",

    },
    AppMaintenance: {
      saveSuccess: 'Application Maintenance Configured successfully !'
    },
    deleteMaintenance: {
      deleteSuccess: 'Record Deleted Successfully !'
    },
    GenericErrorMessage:
      'An error has occurred  while processing your request. Please try again. If problem persist, contact customer service.',
    UnderMaintenance:
      'Site is temporarily unavailable, we are undergoing routine maintenance at this time.',
  };

  static readonly ExternalUrl = {
    CardinalHealth: 'https://www.cardinalhealth.com/en.html',
    Legal:
      'https://www.cardinalhealth.com/en/support/terms-and-conditions-english.html',
    PrivacyPolicy:
      'https://www.cardinalhealth.com/en/support/privacy-policy.html',
    ITAndSecurityControl:
      'https://www.cardinalhealth.com/en/support/compliance-reporting.html'
  };

  static readonly Formatter = {
    Authentication: '{0}',
    UserName: '{username}',
    TrackingIds: '{ids}'
  };

  static TypeGroups = { SearchUser: 23, DMSSoftware: 32, SLA: 33 };
  static TypeCodes = { NPSUserManagement: 4, LogOut: 1201, TimeOut: 1202 };

  static readonly Permissions={
    Base_Schedule_Order_Inventory_Waste:1,
Configuration:2,
UserMangement:3,
Reports:4,
Invoice:5,
SharingBetweenDepartMents:6,
DotOverride:7,
AdministrationOverride:8,
EditInventory:9,
UploadTrainingData:10,
DocumnetRepository:11,
ManageComponentProcedures:12,
Dayboard_read_only_orders:13,
ReadOnlyAccessDocRepo:14
  }

  static readonly ModulesRequired={Basic:1,B2B:2,AdvancedReporting:3,Theranostics:6};

  static readonly Title={Home:'Nuctrac\u2122- Home',
  ScheduleProcedure:'Nuctrac\u2122- Schedule Procedure',
  Batch:'Nuctrac\u2122- Batch Scheduling',
Directory:'Nuctrac\u2122- Directory',
ReceiveShipment:'Nuctrac\u2122- Receive Shipment',
ManageInv:'Nuctrac\u2122- Manage Inventory',
ConfigureTest:'Nuctrac\u2122- Configure Test',
Managewaste:'Nuctrac\u2122- Manage Waste',
ManageInstruments:'Nuctrac\u2122- Manage Instruments',
Surveygroups:'Nuctrac\u2122-Manage Survey Groups',
HPHistory:'Nuctrac\u2122- HP History',
IDNReports:'Nuctrac\u2122- Reports',
DownloadReports:'Nuctrac\u2122- Download Reports',
DocRepo:'Nuctrac\u2122- Document Repository',
Invoice:'Nuctrac\u2122- Invoice',
DigiRad:'Nuctrac\u2122- Digirad Reports',
ManageProducts:'Nuctrac\u2122- Manage Products',
ManagePO:'Nuctrac\u2122- Manage PO',
ManageComponents:'Nuctrac\u2122- Manage Components',
ManageProcedures:'Nuctrac\u2122- Manage Procedures',
MasterConfiguration:'Nuctrac\u2122- Master Configuration',
KitConfiguration:'Nuctrac\u2122- Kit Configuration',
};

  static readonly Preferences = {
    REMOVABLE_ACTIVITY: "1",
    PREVENT_ADMINISTRATION_IF_VARIANCE_IS_OUT_OF_RANGE: "2",
    ADMINISTRATION_VARIANCE_FROM_PRESCRIBED_AMOUNT: "3",
    USE_PHARMACY_CALIBRATION_AS_ASSAY: "4",
    NUMBER_OF_DOSE_LABEL_FOR_AUTO_PRINT: "5",
    AUTO_PRINT_PATIENT_SAFETY_CARDS: "6",
    ALLOW_24_HOUR_TIME_FORMAT: "7",
    DEFAULT_PATIENT_NAME: "8",
    ALLOW_LESS_THAN_ZERO_READINGS_IN_AREA_SURVERY_AND_WIPE_SURVEY_RESULTS: "9",
    BLOCK_RECEIVE_INVENTORY_OPTION_IF_INSTRUMENT_TESTS_HAVE_NOT_BEEN_RUN: "10",
    BLOCK_ASSAY_OR_DOSE_CMPONENT_IF_INSTRUMENT_TESTS_HAVE_NOT_BEEN_RUN: "11",
    PATIENT_WEIGHT_IN_UNITS_OF_LBS_OR_KG: "12",
    REQUIRE_DATE_OF_BIRTH: "13",
    REQUIRE_MRN: "14",
    REQUIRE_PATIENT_VISIT_ID: "15",
    NUMBER_OF_ELUTION_LABEL_FOR_AUTO_PRINT: "16",
    NUMBER_OF_INVENTORY_LABEL_FOR_AUTO_PRINT: "17",
    NUMBER_OF_KIT_LABEL_FOR_AUTO_PRINT: "18",
    NUMBER_OF_DAYS_BETWEEN_DUPLICATE_RX_NUMBERS_FOR_WARNING: "19",
    HIDE_WIPE_TEST_CONTENTS: "20",
    INCOMING_PACKAGE_SURVEY_REQUIRED: "21",
    INCOMING_PACKAGE_WIPE_REQUIRED: "22",
    DISABLE_WASTE_SYSTEM: "23",
    OUTGOING_PACKAGE_SURVEY_REQUIRED: "24",
    OUTGOING_PACKAGE_WIPE_REQUIRED: "25",
    DEFAULT_DISPOSAL_LOCATION_TEXT: "26",
    DISPLAY_DAYBOARD_SUMMARY_LARGE_NUMBERS: "28",
    AREA_WIPE_DEFAULT: "29",
    PACKAGE_BAR_DEFAULT: "30",
    CREATE_WASTE_BIN_AUTO: "31",
    WIPE_TEST_ACTION_LEVEL_DEFAULT: "32",
    WIPE_TEST_COUNT_DEFAULT: "33",
    PACKAGE_DOT_AREA_WIPE: '34',
    wasteBinStatus: '35',
    returnForCreditEnabled: '36',
    safeTracAlertOnAssay: '37',
    PATIENT_HEIGHT_IN_UNITS_OF_IN_OR_CM: '38',
    BATCH_SCHEDULE_PROCEDURE: '40',
    PATIENT_FIRSTNAME_LASTNAME: '42',
    ADMINISTRATION_TIME_ON_DOSING_SCREEN: '43',
    VENDOR_NAME_DEFAULT: '44',
    WIPE_AREA_DEFAULT_SIZE: '46',
    IN_HOUSE_OUTGOING_PACKAGE_WIPE_REQUIRED: '45',
    SHOW_INPUT_PATIENT_NAME_UPPERCASE: '48',
    SERILE_KIT_PREPARATION_AREA_EXTENDED_EXOIRY_TIME: '49',
    SORT_ORDER_DAYBOARD_SCHEDULE_SECTION: '50',
    DEFAULT_HOURS_TO_EXPIRE: '51',
    ADMINISTRATION_ROUTE_REQUIRED: '52',
    ADMINISTRATION_SITE_REQUIRED: '53',
    SHOW_NUCBOT_WIDGET: '54',
    AUTO_POPULATE: '55',
    SYSTEM_TIMEZONE: '56',
    WIPE_TEST_ACTION_LEVEL_IN_HOUSE_WASTE_BIN: '57',
    LIMIT_NUM_OF_ITEM_IN_RETURN_BOX:'58',
    DISABLE_OFFLINE_ORDER : '59',
    DISABLE_MANUFACTURER_ORDER :'61',
    SHOW_DOT_SHIPPER_NONDIGIRAD : '62',
    ENABLE_WRITTEN_DIRECTIVE : '60',
    SHOW_NEW_ASSAY_DOSE_SCREEN : '64',
    MANAGE_PROCEDURE_COMPONENT_EXPORT_BUTTON_VISIBILITY:'70'
    //SB-4278
  }
}

export const AppMessages = {

};

export const Validation = {
};

export const TypeCode = { NPSWO: 1, SYNTRAC: 2, INVOICING: 3, UserRegistration: 4 };

export const MessageFormatter = {
  Limit: '{{limit}}',
  Item: '{{item}}',
  Total: '{{total}}',
  Date: '{{date}}',
};

export const Regex = {
  RestrictSpecialChars: /[^A-Za-z0-9:;<=>?\^{}|~!'#$%&'()*+,.`_@\-\[\]\/\\ ]/g,
  AllowNumericOnly: /^[0-9]*$/,
  AlphabetsOnly: /^[A-Za-z ]*$/,
  AlphaNumericOnly: /^[a-zA-Z0-9 ]*$/,
  Password:
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-!"#\$%\&'\(\)*+,./:;<=>\?@\[\]])(?=\S+$).{6,}$/,
  Email: /.{1,}@.{1,}\..{1,}/,
  Link: /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
  Date: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/,
  //Date: /(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
  Time: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,

  MultipleEmail: /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4};?)+$/,
  NumericOnly: /^\d+$/,
  NumericGTZero: /^[1-9][0-9]*$/,
  Decimal: /^[0-9]+(\.[0-9]*){0,1}$/g,
  DecimalGTZero: /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/g,
  DecimalTwoScale: /^[0-9][0-9]*[.]?[0-9]{0,2}$/,
  DecimalThreeScale: /^[0-9][0-9]*[.]?[0-9]{0,3}$/,
  DecimalFourScale: /^[0-9]*[0-9]*[.]?[0-9]{0,4}$/,
  DecimalSixScale: /^[0-9][0-9]*[.]?[0-9]{0,6}$/,
  DecimalSixPrecisionFiveScale: /^\d{1,1}(\.\d{1,5})?$/,
  DecimalEightPrecisionFiveScale: /^\d{1,3}(\.\d{1,5})?$/,
  DecimalNegativeFourScale: /^[-][0-9][0-9]*[.]?[0-9]{0,4}$/,
  DecimalNegativeSixScale: /^-?[0-9][0-9]*[.]?[0-9]{0,6}$/,
};





export const DateFormat = {
  Default: 'MM/DD/YYYY',
  MMDDYYYY: 'MM/DD/YYYY',
  MMDDYYYYHyphen: 'MM-DD-YYYY',
  YYYYMMDD: 'YYYY-MM-DD',
  DD: 'DD',
  MMDDYYYYHMMSS: 'MM/DD/YYYY HH:mm:ss',
  MMDDYYYYHMM: 'MM/DD/YYYY HH:mm',
  DDMMDDYYYYHMM:'dddd, MM/DD/YYYY HH:mm',
  HHMM: 'HH:mm',
  HHMMA: 'HH:mm A',
  DMDY: 'dddd, MMMM D, YYYY',
  MMMMDYYYY: 'MMMM D, YYYY',
  DMDYHHMM: 'dddd, MMMM D, YYYY HH:mm',
  MMMM: 'MMMM',
  DatePipeFormat: 'yyyy-MM-dd',
  YYYYMMDDTHHMMSS:'YYYY-MM-DD[T]HH:mm:ss'
};


export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

export const TaskStatus={
  Scheduled:11100,
  InProgress:11101,
  Completed:11102
};

export const DocumentRepositoryPermissions = {
  fullAccess: 11,
  readAccessOnly: 14
}

export type DashboardView = 'dayboard' | 'todo' | 'assay-dose';